import dayjs from "dayjs/esm";
import "dayjs/esm/locale/fr-ch";
import duration from "dayjs/esm/plugin/duration";
import utc from "dayjs/esm/plugin/utc";
import timezone from "dayjs/esm/plugin/timezone";

dayjs.locale("fr-ch");
dayjs.extend(duration);
dayjs.extend(utc);
dayjs.extend(timezone);

export function toDate(dateString) {
    return dayjs(dateString).format("DD MMM YYYY");
}

export function toDateTime(dateString) {
    return dayjs(dateString).format("DD MMM YYYY HH:mm");
}

export function toDjangoDate(dateString) {
    return dayjs(dateString).format("YYYY-MM-DD");
}

export function toTime(dateString) {
    return dayjs(dateString).format("HH:mm");
}

export function toDuration(start, end, format = "HH:mm") {
    return dayjs.duration(dayjs(end).diff(dayjs(start))).format(format);
}

export function toISOString(timeString) {
    if (!timeString) {
        return dayjs().tz("Europe/Zurich").format("YYYY-MM-DDTHH:mm:ss");
    }
    try {
        return dayjs.tz(timeString, "Europe/Zurich").format("YYYY-MM-DDTHH:mm:ss");
    } catch (e) {
        return dayjs().tz("Europe/Zurich").format("YYYY-MM-DDTHH:mm:ss");
    }
}

export function previousOpenDayAt(date, hour) {
    let previousOpenDay = dayjs(date).startOf("day").subtract(1, "day");
    while (previousOpenDay.day() === 0 || previousOpenDay.day() === 6) {
        previousOpenDay = previousOpenDay.subtract(1, "day");
    }
    previousOpenDay = previousOpenDay.hour(hour);
    return previousOpenDay;
}

export function sessionFormat(sessionCode) {
    if (typeof sessionCode === "string") {
        return sessionCode.substring(4, 6) + "/" + sessionCode.substring(0, 4);
    }
    return sessionCode;
}

export function sessionParse(session) {
    return session.substring(3, 7) + session.substring(0, 2);
}

export function shortenModule(module) {
    module = module.replace(/Baccalauréat universitaire/g, "Bsc");
    return module;
}

export { dayjs };
